import { IApplicationState } from '../../types/redux';
import { filterTagsByJsonQuery } from '../../utils/tags';

export const selectSearchTags = (state: IApplicationState) => {
  const { tags, nextJsonQuery } = state;

  return filterTagsByJsonQuery(tags, nextJsonQuery);
};

export const selectSearchTagsLength = (state: IApplicationState) => {
  return selectSearchTags(state).length;
};
